export const musicTracks = [
  // '/tracks/1.mp3',
  // '/tracks/2.mp3',
  // '/tracks/3.mp3',
  '/tracks/Axollo- Moonstruck.mp3',
  '/tracks/Axtasia - Light Up The Sky.mp3',
  '/tracks/Clarx - Zig Zag.mp3',
  '/tracks/Creo - Rock Thing.mp3',
  '/tracks/CyberJunkie - First Shot.mp3',
  '/tracks/Def Manic - I Need Ya.mp3',
  '/tracks/Egzod feat. Chris Linton - Wake Up.mp3',
  '/tracks/HYLO - Paradise ft. Akacia.mp3',
  '/tracks/Infraction - Exercise.mp3',
  '/tracks/Infraction - Hard.mp3',
  '/tracks/Limitless - Intense Workout.mp3',
  '/tracks/Mr Speed - XR 351.mp3',
  '/tracks/Mystery Mammal - Knox.mp3',
  '/tracks/NEFFEX - Born A Rockstar.mp3',
  '/tracks/NEFFEX - Cold.mp3',
  '/tracks/Neffex - Destiny.mp3',
  '/tracks/NEFFEX - Fight Back.mp3',
  '/tracks/NEFFEX - Free Me.mp3',
  '/tracks/NEFFEX - Go Down Swinging.mp3',
  '/tracks/NEFFEX - I Just Wanna Be Great.mp3',
  '/tracks/NEFFEX - Immortal.mp3',
  '/tracks/NEFFEX - Pro.mp3',
  '/tracks/NEFFEX- Inspired.mp3',
  '/tracks/NEFFEX-Grateful.mp3',
  '/tracks/NEFFEX-No Turning Back.mp3',
  '/tracks/Never Give Up -Armageddon.mp3',
  '/tracks/Rob Gasser - Supersonic.mp3',
  '/tracks/RocknStock - Dynamic power.mp3',
  '/tracks/Stefano Necchi - Backfire.mp3',
  '/tracks/Stefano Necchi - Ignition.mp3',
]